import React, { useEffect, useState } from "react";
import { countries } from "countries-list";
import { useDispatch, useSelector } from "react-redux";
import { saveShippingInfo } from "../../redux/features/cartSlice";
import MetaData from "../layout/MetaData";
import { useNavigate } from "react-router-dom";
import CheckoutSteps from "./CheckoutSteps";

const Shipping = () => {
    const countriesList = Object.values(countries);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [country, setCountry] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const { shippingInfo } = useSelector((state) => state.cart);
    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (shippingInfo) {
            setName(shippingInfo?.name || "");
            setEmail(shippingInfo?.email || "");
            setAddress(shippingInfo?.address || "");
            setCity(shippingInfo?.city || "");
            setZipCode(shippingInfo?.zipCode || "");
            setPhoneNo(shippingInfo?.phoneNo || "");
            setCountry(shippingInfo?.country || "");
        }
    }, [shippingInfo]);

    const submitHandler = (e) => {
        e.preventDefault();
        const payload = isAuthenticated
            ? { address, city, phoneNo, zipCode, country }
            : { name, email, address, city, phoneNo, zipCode, country };
        dispatch(saveShippingInfo(payload));
        navigate("/confirm_order")
    };

    return (
        <>
            <MetaData title="Shipping Info" />
            <CheckoutSteps shipping />

            {/* Add paddingTop so it does not touch the header */}
            <div
                className="container d-flex align-items-center justify-content-center"
                style={{ paddingTop: "80px", paddingBottom: "50px" }}
            >
                <div className="row justify-content-center w-100">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="card shadow-sm rounded-4 border-0 p-4">
                            <h2 className="fw-bold text-center mb-4" style={{ color: "#e04f6ecd" }}>Shipping Info</h2>

                            <form className="shipping-form" onSubmit={submitHandler}>
                                {!isAuthenticated && (
                                    <>
                                        {/* Name (guests only) */}
                                        <div className="mb-3">
                                            <label htmlFor="name_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                id="name_field"
                                                className="form-control"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Email (guests only) */}
                                        <div className="mb-3">
                                            <label htmlFor="email_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                id="email_field"
                                                className="form-control"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </>
                                )}
                                {/* Address */}
                                <div className="mb-3">
                                    <label htmlFor="address_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                        Address
                                    </label>
                                    <input
                                        type="text"
                                        id="address_field"
                                        className="form-control"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* City */}
                                <div className="mb-3">
                                    <label htmlFor="city_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                        City
                                    </label>
                                    <input
                                        type="text"
                                        id="city_field"
                                        className="form-control"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Phone */}
                                <div className="mb-3">
                                    <label htmlFor="phone_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                        Phone No
                                    </label>
                                    <input
                                        type="tel"
                                        id="phone_field"
                                        className="form-control"
                                        value={phoneNo}
                                        onChange={(e) => setPhoneNo(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Zip Code */}
                                <div className="mb-3">
                                    <label htmlFor="zip_code_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                        Zip Code
                                    </label>
                                    <input
                                        type="number"
                                        id="zip_code_field"
                                        className="form-control"
                                        value={zipCode}
                                        onChange={(e) => setZipCode(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Country */}
                                <div className="mb-3">
                                    <label htmlFor="country_field" className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>
                                        Country
                                    </label>
                                    <select
                                        id="country_field"
                                        className="form-select"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        required
                                    >
                                        <option value="">Select Country</option>
                                        {countriesList.map((c) => (
                                            <option key={c.name} value={c.name}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Submit */}
                                <div className="d-grid">
                                    <button id="shipping_btn" type="submit" className="btn View-btn py-2 fw-semibold">
                                        CONTINUE
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Shipping;